@if (resourceBadges.length > 0) {
  <div class="badges-wrap">
    @for (badge of resourceBadges; track trackByBadge($index)) {
      <div class="resource-badge"
        [ngStyle]="{ lineHeight: iconSize, height: iconSize, width: iconSize }">
        <!-- <img src="assets/img/profile-user.svg" [attr.width]="iconSize" [attr.height]="iconSize" /> -->
        <!-- TODO: Replace inline svg with the icon library component. Add the user SVG to the library -->
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
          y="0px" width="45.916px" height="45.916px" viewBox="0 0 45.916 45.916"
          style="enable-background:new 0 0 45.916 45.916;" xml:space="preserve">
          <g>
            <g>
					<path [attr.fill]="badge.color" d="M30.061,18.237c2.127-1.916,3.476-4.683,3.476-7.772C33.536,4.684,28.85,0,23.07,0C17.29,0,12.604,4.685,12.604,10.465
			c0,3.085,1.343,5.85,3.467,7.766c-5.441,0.422-9.74,4.928-9.779,10.477L6.224,40.154c-0.01,1.525,0.59,2.99,1.665,4.072
			c1.075,1.08,2.537,1.689,4.062,1.689h10.151h11.794c3.15,0,5.709-2.543,5.729-5.693l0.068-11.361
			c0.021-2.826-1.089-5.538-3.083-7.544C34.851,19.543,32.526,18.465,30.061,18.237z" />
              </g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
          </svg>
          <span class="vet-initials"
            [ngStyle]="{left: badge.initials.length === 1 ? '5px' : '3px'}">
            {{ badge.initials}}
          </span>
        </div>
      }
    </div>
  }